import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgRemix = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.82291 3.76136C9.50636 2.66393 10.7092 2 11.998 2C13.2869 2 14.4897 2.66393 15.1732 3.76136L16.6807 6.17104L17.7352 5.56178C18.0632 5.37042 18.4733 5.39775 18.774 5.62818C19.0747 5.8586 19.2075 6.24914 19.1099 6.61626L18.196 10.0296C18.0632 10.5295 17.5477 10.8263 17.0478 10.6936L13.6344 9.77968C13.2673 9.68205 12.9978 9.37352 12.9471 8.99859C12.8963 8.62367 13.0799 8.25265 13.4079 8.06519L14.5171 7.42469L13.0525 5.08532C12.826 4.72211 12.4276 4.4995 11.998 4.4995C11.5684 4.4995 11.1701 4.72211 10.9436 5.08532L10.2601 6.17885C9.90081 6.75686 9.14315 6.94041 8.55733 6.58892C7.9598 6.22962 7.76843 5.44852 8.13945 4.85489L8.82291 3.76136ZM18.774 11.8379C19.3598 11.4864 20.1175 11.6699 20.4768 12.2479L21.4297 13.775C21.7969 14.3647 21.9921 15.0403 21.9999 15.7355C22.0117 17.8093 20.3323 19.5004 18.2585 19.5004L14.4975 19.4965V20.7462C14.4975 21.1251 14.271 21.4687 13.9195 21.6132C13.568 21.7577 13.1658 21.6796 12.8963 21.4102L10.3968 18.9107C10.0297 18.5435 10.0297 17.9499 10.3968 17.5867L12.8963 15.0872C13.1658 14.8177 13.568 14.7396 13.9195 14.8841C14.271 15.0286 14.4975 15.3723 14.4975 15.7511V17.0009H18.2546C18.942 17.0009 19.5004 16.4385 19.4965 15.7511C19.4965 15.5207 19.4301 15.2942 19.3091 15.0989L18.3561 13.5719C17.9851 12.9783 18.1726 12.1972 18.774 11.8379ZM4.53471 10.6272L3.40603 9.97496C3.07797 9.78359 2.89441 9.41648 2.94518 9.04155C2.99595 8.66663 3.26543 8.3581 3.63254 8.26046L7.04592 7.34658C7.54582 7.21379 8.06134 7.51061 8.19413 8.01051L9.108 11.42C9.20564 11.7871 9.07285 12.1737 8.77213 12.4081C8.47141 12.6424 8.06134 12.6658 7.73328 12.4745L6.69833 11.8769L4.68702 15.095C4.56595 15.2903 4.49956 15.5168 4.49956 15.7472C4.49565 16.4346 5.05413 16.997 5.7415 16.997H6.99905C7.69032 16.997 8.2488 17.5555 8.2488 18.2467C8.2488 18.938 7.69032 19.4965 6.99905 19.4965H5.7415C3.66769 19.4965 1.98834 17.8093 2.00006 15.7316C2.00397 15.0364 2.19924 14.3608 2.57026 13.7711L4.53471 10.6272Z", fill: props.fill }));
});
export default SvgRemix;
